import { AccountJournalsStateInterface } from '.';

function state(): AccountJournalsStateInterface {
  return {
    accountJournals: [],
  };
}

export default state;
